import { render, staticRenderFns } from "./PaginationSelect.vue?vue&type=template&id=219d32ab"
import script from "./PaginationSelect.vue?vue&type=script&lang=ts"
export * from "./PaginationSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports